import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../../services/api';

const name = 'deleteApplicationInfo';
const initialState = createInitialState();

function createInitialState() {
    return {
        done: false,
        error: false,
        spinner: false,
        deleteApplicationInfo: null,
    };
}

export const deleteApplicationInfo = createAsyncThunk('deleteApplicationInfo', async (id, { rejectWithValue }) => {
    try {
        const response = await api.delete(`/super/api/application-info/delete/${id}`);
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }
});

const deleteApplicationInfoSlice = createSlice({
    name: name,
    initialState,
    reducers: {
        resetDeleteApplicationInfo: state => {
            state.done = false;
            state.error = false;
            state.spinner = false;
            state.deleteApplicationInfo = null;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(deleteApplicationInfo.pending, state => {
                state.spinner = true;
                state.error = false;
            })
            .addCase(deleteApplicationInfo.fulfilled, (state, action) => {
                state.done = true;
                state.spinner = false;
                state.error = false;
                state.deleteApplicationInfo = action.payload;
            })
            .addCase(deleteApplicationInfo.rejected, (state, action) => {
                state.done = false;
                state.spinner = false;
                state.error = action.payload;
            });
    },
});

export const { resetDeleteApplicationInfo } = deleteApplicationInfoSlice.actions;
export const deleteApplicationInfoReducer = deleteApplicationInfoSlice.reducer;
